import { gsap } from 'gsap';

export function initBlockAccentCards(parent) {
  if (!parent) return;

  const cards = parent.querySelectorAll('.block-accent-cards__item');
  cards.forEach((card, index) => {
    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      transformOrigin: 'center center',
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: 'top 75%',
        toggleActions: 'play none none none',
      },
    });
    tl.to(card, {
      opacity: 1,
      scale: 1.02,
      duration: 0.5,
      ease: 'power1.out',
      delay: index * 0.1,
    }).to(card, {
      scale: 1,
      duration: 0.3,
      ease: 'power1.inOut',
    });
  });
}

export function initAllAccentCardsBlocks() {
  const blocks = document.querySelectorAll('.js-block-accent-cards');
  blocks.forEach((block) => initBlockAccentCards(block));
}
